import auditProvider from "src/providers/audit-provider";
import type { ListAuditLogsParams } from "src/types";

const auditQueries = {
	listAuditLogs: (params: ListAuditLogsParams = {}) => ({
		queryKey: ["listAuditLogs", params],
		queryFn: () => auditProvider.listAuditLogs(params),
		staleTime: 30000, // 30 seconds
	}),

	getUserAuditLogs: (userId: string, limit = 20, offset = 0) => ({
		queryKey: ["userAuditLogs", userId, limit, offset],
		queryFn: () => auditProvider.getUserAuditLogs(userId, limit, offset),
		enabled: Boolean(userId),
		staleTime: 30000, // 30 seconds
	}),
};

export default auditQueries;
